import { Box } from '@chakra-ui/react'
import { useStore } from '@tanstack/react-store'
import { Route } from 'react-router-dom'
import { authStore } from 'shared/store/auth'

/*export const getAccess = (authorities, hasAnyRole) => {
    if (authorities && authorities.length !== 0) {
        if (hasAnyRole.length === 0) {
            return true;
        }
        return hasAnyRole.includes(authorities);
    }
    return false;
};*/

export const getAccess = (authorities, hasAnyRoles) => {
  if (authorities && authorities.length !== 0) {
    if (hasAnyRoles.length === 0) {
      return true
    }
    return hasAnyRoles.some((auth) => authorities.includes(auth))
  }
  return false
}

export const PrivateRoute = ({ path, hasAnyRole, children, ...props }) => {
  const { user } = useStore(authStore)
  const access = getAccess(user?.roles, hasAnyRole)

  return (
    <Route path={path} {...props}>
      {access ? children : 'Нет доступа'}
    </Route>
  )
}

export const PrivateBox = ({ role, hasAnyRole, children, ...props }) => {
  const { user } = useStore(authStore)
  const access = getAccess(user?.roles, hasAnyRole)
  
  if (access) {
    return <Box {...props}>{children}</Box>
  }
  return null
}

export const Private = ({  hasAnyRole, children }) => {
  const { user } = useStore(authStore)

  const access = getAccess(user?.roles, hasAnyRole)
  return <>{access ? children : null}</>
}
